import React, { cloneElement, useMemo, useCallback } from 'react';
import { Modal as OModal } from '@osui/ui';
import { useBoolean } from 'huse';
import { createFormActions } from '@formily/react';
import { formValidate } from '../../utils';
import { Form } from '../../Form';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Modal({
  trigger,
  children: childrenIn,
  visible: visibleIn,
  onCancel,
  onOk,
  formProps = {},
  ...props
}) {
  const [visible, {
    on: setVisibleTrue,
    off: setVisibleFalse
  }] = useBoolean(false);
  const [confirmLoading, {
    on: setLoadingTrue,
    off: setLoadingFalse
  }] = useBoolean(false);
  const actions = useMemo(() => createFormActions(), []);
  const handelCancel = useCallback(e => {
    setVisibleFalse();
    onCancel && onCancel(e);
  }, [onCancel, setVisibleFalse]);
  const handleOk = useCallback(async () => {
    try {
      await formValidate(actions);
      setLoadingTrue();
      const {
        values
      } = await actions.getFormState();
      await onOk(values, actions);
      setLoadingFalse();
      setVisibleFalse();
    } catch (e) {
      setLoadingFalse(); // eslint-disable-next-line

      console.error(e);
    }
  }, [actions, setLoadingFalse, setLoadingTrue, onOk, setVisibleFalse]);
  const isVisible = typeof visibleIn === 'boolean' ? visibleIn : visible;
  const children = useMemo(() => {
    if (!isVisible) {
      return null;
    }

    if (typeof childrenIn === 'function') {
      return childrenIn({
        actions
      });
    }

    return /*#__PURE__*/_jsx(Form, {
      actions: actions,
      ...formProps,
      children: childrenIn
    });
  }, [actions, childrenIn, formProps, isVisible]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [trigger && /*#__PURE__*/cloneElement(trigger, {
      onClick: setVisibleTrue
    }), /*#__PURE__*/_jsx(OModal, {
      destroyOnClose: true,
      visible: isVisible,
      onCancel: handelCancel,
      onOk: handleOk,
      confirmLoading: confirmLoading,
      ...props,
      children: children
    })]
  });
}
Modal.displayName = "Modal";
//# sourceMappingURL=es/FormUI/Modal/index.js.map